export default "__VITE_ASSET__99euNo5q__"